import React from 'react';
import { Search } from 'lucide-react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  icon?: React.ReactNode;
  fullWidth?: boolean;
}
export function Input({
  label,
  error,
  icon,
  fullWidth = false,
  className = '',
  ...props
}: InputProps) {
  return <div className={`${fullWidth ? 'w-full' : ''} flex flex-col gap-1.5`} data-id="element-306">
      {label && <label className="text-sm font-medium text-gray-700" data-id="element-307">{label}</label>}
      <div className="relative" data-id="element-308">
        {icon && <div className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" data-id="element-309">
            {icon}
          </div>}
        <input className={`
            flex h-10 w-full rounded-full border border-gray-300 bg-white px-4 py-2 text-sm placeholder:text-gray-400 
            focus:outline-none focus:ring-2 focus:ring-navy-primary/20 focus:border-navy-primary disabled:cursor-not-allowed disabled:opacity-50
            ${icon ? 'pl-10' : ''}
            ${error ? 'border-red-alert focus:ring-red-alert/20' : ''}
            ${className}
          `} {...props} data-id="element-310" />
      </div>
      {error && <span className="text-xs text-red-alert" data-id="element-311">{error}</span>}
    </div>;
}